/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useEffect, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./history.module.sass";
import cn from "classnames";
import CustomLinkForAccept from "components/CustomLink";
import { useAppSelector } from "toolkit/hooks";
import { userAPI } from "libs/apiClient/User";

const dependencies = [
	"system.organization.read",
	"system.employee_dictionary.read",
	"system.user_dictionary.read",
	"dictionary.okved.read",
	"dictionary.activity_area.read",
	"dictionary.ownership_type.read",
	"dictionary.document_patterns.read",
	"dictionary.person_status.read",
	"dictionary.construction_objects.read",
	"dictionary.organization_marker.read",
	"dictionary.object_status.read",
	"dictionary.object_type.read",
	"dictionary.threat_consequence.read",
	"dictionary.threat.read",
	"dictionary.inapplicability_reason.read",
	"dictionary.significance_criteria.read",
	"dictionary.business_process_pattern.read",
	"categorization.commission.read",
	"categorization.business_process_registry.read",
	"categorization.object_registry.read",
	"categorization.object_list.read",
	"categorization.threat_model.read",
	"categorization.damage.read",
	"categorization.step_5.read",
	"categorization.step_6.read",
	"categorization.step_7.read",
	"document.organization.read",
	"dictionary.threat_model_template.read",
	// "",
	// "dictionary.organization_marker.read",
	// "dictionary.threat.read",
	// "dictionary.object_status.read",
	// "dictionary.inapplicability_reason.read",
	// "dictionary.object_type.read",
	// "dictionary.significance_criteria.read",
	// "dictionary.ownership_type.read",
	// "dictionary.activity_area.read",
	// "dictionary.threat_consequence.read",
	// "dictionary.person_status.read",
	// "dictionary.construction_objects.read",
	// "dictionary.document_patterns.read",
	// "dictionary.business_process_pattern.read",
	// "system.organization.read",
	// "system.user_dictionary.read",
	// "system.employee_dictionary.read",
	// "document.organization.read",
	// "categorization.commission.read",
	// "categorization.business_process_registry.read",
	// "categorization.object_registry.read",
	// "categorization.object_list.read",
	// "categorization.threat_model.read",
	// "categorization.step_5.read",
	// "categorization.step_6.read",
	// "categorization.step_7.read",
];

const History = () => {
	const [rules, setRules] = useState({
		"system.organization.read": false,
		"system.employee_dictionary.read": false,
		"system.user_dictionary.read": false,
		"dictionary.okved.read": false,
		"dictionary.activity_area.read": false,
		"dictionary.ownership_type.read": false,
		"dictionary.document_patterns.read": false,
		"dictionary.person_status.read": false,
		"dictionary.construction_objects.read": false,
		"dictionary.organization_marker.read": false,
		"dictionary.object_status.read": false,
		"dictionary.object_type.read": false,
		"dictionary.threat_consequence.read": false,
		"dictionary.threat.read": false,
		"dictionary.inapplicability_reason.read": false,
		"dictionary.significance_criteria.read": false,
		"dictionary.business_process_pattern.read": false,
		"dictionary.threat_model_template.read": false,
		// "categorization.commission.read": false,
		// "categorization.business_process_registry.read": false,
		// "categorization.object_registry.read": false,
		// "categorization.object_list.read": false,
		// "categorization.threat_model.read": false,
		// "categorization.damage.read": false,
		// "categorization.step_5.read": false,
		// "categorization.step_6.read": false,
		// "categorization.step_7.read": false,
		// "document.organization.read": false,
	});

	const profile = useAppSelector((state) => state.profile.profile);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, dependencies).then((r) => {
			if (r && r.data.length) {
				setRules((prevState) => {
					const newState = { ...prevState };
					r.data.forEach((_: string) => {
						const key = _ as keyof typeof newState;
						newState[key] = true;
					});
					return newState;
				});
			}
		});
		//eslint-disable-next-line
	}, []);

	return (
		<div className={"step-wrapper"}>
			<HeadPage title={"История действий"} />
			<div className={sass.wrapper}>
				<div className={sass.col}>
					<p className={sass.caption}>Справочники</p>
					<div className={sass.list}>
						<p className={sass.title}>Основные</p>
						<CustomLinkForAccept
							state={{ link: "/audit/organization" }}
							url={"organization"}
							switched={rules["system.organization.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.structure)} />
							Организационная структура
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/employee" }}
							url={"employee"}
							switched={rules["system.employee_dictionary.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.employees)} />
							Сотрудники
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/user" }}
							url={"user"}
							switched={rules["system.user_dictionary.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.users)} />
							Пользователи
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/role" }}
							url={"role"}
							switched={profile.admin}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.roles)} />
							Настройки ролей
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/okved" }}
							url={"okved"}
							switched={rules["dictionary.okved.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.okved)} />
							коды ОКВЭД
						</CustomLinkForAccept>
					</div>
					<div className={sass.list}>
						<p className={sass.title}>Дополнительные справочники</p>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/activity-area" }}
							url={"activity-area"}
							switched={rules["dictionary.activity_area.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.areasActivity)} />
							Сферы деятельности
						</CustomLinkForAccept>
						{/*<CustomLinkForAccept*/}
						{/*	state={ { link: '/audit/dictionary/property-type' } }*/}
						{/*	url={ 'property-type' }*/}
						{/*	switched={ true }*/}
						{/*	linkStyle={ sass.item }>*/}
						{/*	<div className={ cn( sass.icon, sass.typesOfActivity ) } />*/}
						{/*	Виды деятельности*/}
						{/*</CustomLinkForAccept>*/}
						<CustomLinkForAccept
							state={{
								link: "/audit/dictionary/ownership-type",
							}}
							url={"ownership"}
							switched={rules["dictionary.ownership_type.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.ownerships)} />
							Виды владения
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{
								link: "/audit/dictionary/organization-document-pattern",
							}}
							url={"organization-document-template"}
							switched={rules["dictionary.document_patterns.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.templates)} />
							Шаблоны документов компании
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/person-status" }}
							url={"person-status"}
							switched={rules["dictionary.person_status.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.statusesEmployee)} />
							Статусы сотрудников
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/construction-object" }}
							url={"construction-object"}
							switched={rules["dictionary.construction_objects.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.kapStroy)} />
							Объекты капитального строительства
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/organization-marker" }}
							url={"organization-marker"}
							switched={rules["dictionary.organization_marker.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.markers)} />
							Маркеры организаций
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/object-status" }}
							url={"object-status"}
							switched={rules["dictionary.object_status.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.objectStatuses)} />
							Статусы объектов
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/object-type" }}
							url={"object-type"}
							switched={rules["dictionary.object_type.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.objects)} />
							Типы объектов
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/threat-consequence" }}
							url={"threat-consequence"}
							switched={rules["dictionary.threat_consequence.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.consequences)} />
							Последствия реализации угроз
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/threat" }}
							url={"threat"}
							switched={rules["dictionary.threat.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.threats)} />
							Угрозы
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{
								link: "/audit/dictionary/inapplicability-reason",
							}}
							url={"inapplicability-reason"}
							switched={rules["dictionary.inapplicability_reason.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.reasons)} />
							Причины неприменимости показателей критериев значимости
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/dictionary/significance-criteria" }}
							url={"significance-criteria"}
							switched={rules["dictionary.significance_criteria.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.indicators)} />
							Показатели критериев значимости
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{
								link: "/audit/dictionary/business-process-pattern",
							}}
							url={"business-process-template"}
							switched={rules["dictionary.business_process_pattern.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.BP)} />
							Шаблоны реестра бизнес-процессов
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{
								link: "/audit/dictionary/threat-model-template",
							}}
							url={"business-process-template"}
							switched={rules["dictionary.threat_model_template.read"]}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.threatModel)} />
							Шаблоны модели угроз
						</CustomLinkForAccept>
					</div>
				</div>
				<div className={sass.col}>
					<p className={sass.caption}>Категорирование</p>
					<div className={sass.list}>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/1" }}
							url={"step-one"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.commission)} />
							1.1 Создание комиссии по категорированию ОКИИ
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/2/1" }}
							url={"step-two-dot-one"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.restoreBP)} />
							2.1 Добавление бизнес-процессов в реестр
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/2/2" }}
							url={"step-two-dot-two"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.CreateBP)} />
							2.2 Создание реестра объектов
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/3" }}
							url={"step-three"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.OKIIEnums)} />
							3.1 Формирование перечня ОКИИ по результатам актуализации реестра бизнес-процессов и объектов
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/4/1" }}
							url={"step-four-dot-one"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.mu)} />
							4.1 Формирование модели угроз
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/4/2" }}
							url={"step-four-dot-two"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.calculate)} />
							4.2 Расчет экономического ущерба
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/5" }}
							url={"step-five"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.categoryOkii)} />
							5.1 Присвоение категории ОКИИ
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/6" }}
							url={"step-six"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.resultDocs)} />
							6.1 Подготовка и отправка результирующих документов
						</CustomLinkForAccept>
						<CustomLinkForAccept
							state={{ link: "/audit/categorization/7" }}
							url={"step-seven"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.finish)} />
							7.1 Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса
						</CustomLinkForAccept>
					</div>
					<div className={sass.list} />
				</div>
				<div className={sass.col}>
					<p className={sass.caption}>Документы</p>
					<div className={sass.list}>
						<CustomLinkForAccept
							state={{ link: "/audit/document" }}
							url={"docs"}
							switched={true}
							fakeLinkStyle={sass.fake}
							linkStyle={sass.item}>
							<div className={cn(sass.icon, sass.docs)} />
							Документы организации
						</CustomLinkForAccept>
						{/*<CustomLinkForAccept state={link:'}} url={ 'docs-categorized' } switched={ true } linkStyle={ sass.item }>*/}
						{/*	<div className={ cn( sass.icon, sass.docsCategory ) } />*/}
						{/*	Документы категорирования*/}
						{/*</CustomLinkForAccept>*/}
					</div>
					<div className={sass.list} />
				</div>
			</div>
		</div>
	);
};
export default React.memo(History);
